import React from 'react';
import { Link } from "react-router-dom";
import { PlayCircleOutlineOutlined, BeenhereOutlined } from '@mui/icons-material';
import styled from 'styled-components';

import Button from '../../../Button';

import SidebarHeader from '../../layout/SidebarHeader';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    justify-content: flex-start;
  }
  .btn {
    width: 100%;
    max-width: 40rem;
    margin: 0 auto;
    font-size: 15px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;

    svg {
      font-size: 2rem;
      margin-right: 24px;
    }

    &.blank-btn {
      border: 2px solid rgba(255, 255, 255, 0.5);
      background-color: transparent;
      color: rgba(255, 255, 255, 0.5);
      padding: 1rem .75rem;

      &:hover {
        color: #e5e5e5;
        border: 2px solid #e5e5e5; 
      }

      &:focus {
        box-shadow: none;
      }
    }
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 40rem;
  margin: 0 auto 5rem;
  text-align: center;
  @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    margin: 2rem auto 8.5rem;
  }
  figure {
    width: 100%;
    height: 22rem;
    background: ${({ theme }) => theme.backgroundColor.createProjectPlaceholder};
    margin: 0 0 3.5rem;
  }
  h2 {
    color: ${({ theme }) => theme.textColor.default};
    font-weight: 500;
    font-size: 28px;
    line-height: 33px;
  }
  p {
    margin: 1.5rem 0 4rem;
    font-size: 16px;
    line-height: 22px;
    color: #E5E5E5;
    font-weight: 400;
    font-family: "Open Sans";
  }
`

const CreateProject = ({ handleCreateProject, onClose }) => {
  const handleCreateProject0 = () => {
    handleCreateProject();
  }
  return (
    <Wrapper>
      <SidebarHeader onClose={onClose} />
      <Content>
        <h2>Create a Project</h2>
        <p>Virtual site visit project with 3D assets and collaboration functions.</p>
        <Button onClick={() => handleCreateProject0()}><BeenhereOutlined />Create a Project</Button>
      </Content>
      <Link to={{ pathname: 'https://youtu.be/0Jy1GGQ_UTA' }} className="btn blank-btn" target="_blank"><PlayCircleOutlineOutlined /> Watch Tutorial</Link>
    </Wrapper>
  );
}

export default CreateProject;